// extracted by mini-css-extract-plugin
export var columnList = "_du-0";